import { useQuery } from '@apollo/client/react';

import {
  GetAccountUserGroupsDocument,
  type GetAccountUserGroupsQueryResult,
  type GetAccountUserGroupsQueryVariables
} from '../AccountDetails/graphql';
import type { AccountUserGroup } from '../AccountDetails/types';

type DefaultUserGroupResult = Omit<GetAccountUserGroupsQueryResult, 'accountUserGroups'> & { userGroup: string | null };

const useDefaultUserGroup = (accountId: string): DefaultUserGroupResult => {
  const { data, ...rest } = useQuery<GetAccountUserGroupsQueryResult, GetAccountUserGroupsQueryVariables>(
    GetAccountUserGroupsDocument,
    { variables: { accountId } }
  );

  const defaultUserGroup = data?.accountUserGroups?.filter((userGroup: AccountUserGroup) => {
    return userGroup.isDefaultRole;
  });

  return {
    ...rest,
    userGroup: defaultUserGroup?.[0]?.userGroupId || null
  };
};

export { useDefaultUserGroup };
